<div class="suite-canvas-dialog">
  <div class="suite-canvas-header">
    <span class="suite-canvas-title">{{ data.suiteName }}</span>
    <button class="suite-canvas-close" (click)="close()">✕</button>
  </div>
  <div class="suite-canvas-body">
    <div *ngIf="loading" class="suite-canvas-loading">
      <span>Loading artifact...</span>
    </div>
    <div *ngIf="!loading && tabsList.length > 0">
      <ze-canvas-component2
        [tabsList]="tabsList"
        [currentIndex]="0"
        (indexRemoved)="onTabRemoved($event)"
        (indexSelected)="onIndexSelected($event)"
        (canvas)="onCanvas($event)"
        (delete)="onDelete($event)">
      </ze-canvas-component2>
    </div>
    <div *ngIf="!loading && tabsList.length === 0" class="suite-canvas-empty">
      No steps found for this artifact.
    </div>
  </div>
</div>